import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import AffiliateCorporateMembershipController from "../Controller/affiliate_corporate_membership_controller.ts";
import { RiFileExcel2Line } from "react-icons/ri";

const AffiliateCorporateMembershipListExcel = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    AffiliateCorporateMembershipController.getDataForExcel().then((response) => {
      console.log(response.main_data);

      const formattedData = response.main_data.map((item, index) => {
        const dateOnly = item.payment_datetime_created 
          ? item.payment_datetime_created.split(" ")[0] 
          : ""; // Extract date only

        return {
          "No.": index + 1,
          "Name of Member": item.company_name,
          "Membership No.": item.memberID,
          "Co./Organisation No.": item.company_number,
          "Appointed Representative Name": item.appointed_representative_name,
          "Appointed Representative Phone": item.appointed_representative_hp_no,
          "Appointed Representative Email": item.appointed_representative_email,
          "Alternate Representative Name": item.alternate_representative_name,
          "Alternate Representative Phone": item.alternate_representative_hp_no,
          "Alternate Representative Email": item.alternate_representative_email,
          "Other Representative Name": item.other_representative_name,
          "Other Representative Phone": item.other_representative_hp_no,
          "Other Representative Email": item.other_representative_email,
          "Address": item.company_registered_address,
          "Telephone": item.company_telephone_number,
          "Fax": item.company_fax,
          "Tin No.": item.e_invoice_pin
        };
      });

      setRows(formattedData);
    });
  }, []);

  const exportToExcel = () => {
    if (rows.length === 0) {
      alert("No data available!");
      return;
    }

    // Create worksheet with formatted data
    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Auto-adjust column widths
    const columnWidths = Object.keys(rows[0]).map((key) => ({
      wch: Math.max(
        key.length, // Header length
        ...rows.map((row) => (row[key] ? row[key].toString().length : 0)) // Max data length
      ),
    }));

    worksheet["!cols"] = columnWidths;

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "AFC Membership List");

    // Export as .xlsx file
    XLSX.writeFile(workbook, `AffiliateCorporateMembershipList.xlsx`);
  };

  return (
    <Button variant="contained" color="success" onClick={exportToExcel} sx={{ marginBottom: "20px", fontWeight: "bold" }}>
      <RiFileExcel2Line fontSize={20} style={{ marginRight: "10px" }} /> Excel
    </Button>
  );
};

export default AffiliateCorporateMembershipListExcel;
